import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { pageKey } from '@dashboard/lib/queryKeys';

import usePage from '@dashboard/hooks/usePage';

import PageEditView from '../../components/PageEditView';
import PageFieldsForm from '../../components/PageFieldsForm';
import PageFilesForm from '../../components/PageFilesForm';

import Divider from '@dashboard/components/Divider';
import Link from '@dashboard/components/Link';

import FilesForm from '../PageSettings/components/FilesForm';

import FormDescriptionForm from './components/FormDescriptionForm';
import FormEditForm from './components/FormEditForm';

const PageForm = () => {
  const { page } = usePage();
  const queryClient = useQueryClient();

  return (
    <PageEditView
      tabs={[
        { path: '/details', label: 'Details', component: <FormEditForm /> },
        {
          path: '/description',
          label: 'Description',
          component: (
            <FormDescriptionForm
              onChange={() => queryClient.invalidateQueries({ queryKey: pageKey(page._id) })}
            />
          ),
        },
        {
          path: '/file-downloads',
          label: 'File downloads',
          component: (
            <>
              <PageFilesForm
                onChange={() => queryClient.invalidateQueries({ queryKey: pageKey(page._id) })}
              />

              {page.productType === 'subscription' && (
                <>
                  <Divider className="my-8" />
                  <FilesForm />
                </>
              )}
            </>
          ),
          description: <>Add files to create a lead magnet.</>,
        },
        {
          path: '/fields',
          label: 'Fields',
          component: <PageFieldsForm />,
          description: (
            <>
              Capture customer information & preferences.{' '}
              <Link to="/help/articles/how-to-add-custom-fields" blank>
                Learn more
              </Link>
            </>
          ),
        },
      ]}
    />
  );
};

export default PageForm;
